import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const nextTabNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('nextTab'),
    controlValues: z.object({
        tabGroupId: z.string(),
    }),
});
export type NextTabNodeCfgSchema = z.infer<typeof nextTabNodeCfgSchema>;

export const nextTabNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'nextTab'>) => ({}),
        outputs: (_cfg: NodeCfg<'nextTab'>) => {
            const ret: Record<'activeTabIndex', 'number'> = {
                activeTabIndex: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<NextTabNodeCfgSchema>;
